// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var Highcharts$ReactHooksTemplate = require("../../common/Highcharts.res.js");

function MapComponent(props) {
  var chartHeight = props.chartHeight;
  var enlarged = props.enlarged;
  var mapAttribute = props.mapAttribute;
  var mapHeight = enlarged ? "50%" : (
      chartHeight === "h-64" ? "216" : "432"
    );
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Highcharts$ReactHooksTemplate.HighchartsBinding.make, {
                    colorAxis: Highcharts$ReactHooksTemplate.buildColorAxisDict({
                          dataClasses: {
                            hd: {
                              from: -100,
                              to: 0,
                              color: "#fc8181"
                            },
                            tl: {
                              hd: {
                                from: 0,
                                to: 50,
                                color: "#f6ad55"
                              },
                              tl: {
                                hd: {
                                  from: 50,
                                  to: 100,
                                  color: "#68d391"
                                },
                                tl: /* [] */0
                              }
                            }
                          },
                          minColor: "#fc8181",
                          maxColor: "#68d391"
                        }),
                    series: mapAttribute.series,
                    drilldown: mapAttribute.drilldown,
                    mapHeight: mapHeight,
                    dataLabels: enlarged
                  }),
              className: chartHeight
            });
}

var make = MapComponent;

exports.make = make;
/* react/jsx-runtime Not a pure module */
